export const SET_IS_LOGGED_IN = 'SET_IS_LOGGED_IN';
export const SET_BEARER_TOKEN = 'SET_BEARER_TOKEN';
export const SET_USERNAME = 'SET_USERNAME';
export const SET_PASSWORD = 'SET_PASSWORD';